// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tgd6q","newExpiryDate":"styles_newExpiryDate__2Dsec","footer":"styles_footer__36dhp"};